import axios from "axios";
import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ContactForm = () => {
  const recaptchaRef = useRef(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhoneNo] = useState("");
  const [message, setMessage] = useState("");

  // const Site_Key = "6Ldi7EAsAAAAAD0hvK3eJirqbAxL0U4s_Zl8i266"; //Local
  const Site_Key = "6LcN8kcsAAAAAPdpBPmv9yNBKdCuo-MhCFoZoflQ";  //Live
  
  // const Api_Url = "http://192.168.1.230:8085/main/webreact/";  //local
  const Api_Url = "https://app.cheransoftwares.com/webreact/"; //live
  
   const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "");
    setPhoneNo(digitsOnly.slice(0, 10));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const captcha_token = recaptchaRef.current.getValue();
    console.log("captcha_token d",captcha_token)
    if (!captcha_token) {
      alert("Please verify you are not a robot");
      return;
    }
    try {
      const payload = {
        name,
        lead_email: email,
        quick_country_code: "91",
        phonenumber1: phone_no,
        note_name: message,
        captcha_token,
      };

      const response = await axios.post(
          `${Api_Url}webapp_leads/website_form_store`,
          payload,
          { headers: { 'Content-Type': 'application/json' }}
        );
      alert("Form submitted successfully");
      recaptchaRef.current.reset();
      setName("");
      setEmail("");
      setPhoneNo("");
      setMessage("");
    } catch (error) {
      console.error("Axios error:", error.response?.data || error.message);
      alert(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Your Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />
      <input
        type="email"
        placeholder="Your Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <input
      type="text"
      placeholder="Your Phone"
      value={phone_no}
      onChange={handleChange}
      maxLength={10}           // optional safety
      inputMode="numeric"      // mobile keyboard shows numbers
      pattern="\d{10}"         // HTML validation on submit
      required
    />


      <textarea
        placeholder="Message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        required
      />
      <ReCAPTCHA
          sitekey={Site_Key}
          ref={recaptchaRef}
        />

        <button type="submit" className="btn theme-btn-1 mt-3">
          Send Message
        </button>
    </form>
  );
};

export default ContactForm;
